import { isContentMax } from "components/utility/page-responsive/PageResponsive";

const animateInfographic = (parentContainer) => {
	if (parentContainer) {
		const infographicHeadline = parentContainer.querySelector(".ddiff-animated-exhibit-border");
		if (infographicHeadline) {
			infographicHeadline.classList.add("ddiff-animated-exhibit-border-animate");
		}
	}
};

const animateInfographicHeadline = (entry, hasParentContainer) => {
	const infographicHeadline = hasParentContainer
		? entry.querySelector(".ddiff-animated-exhibit-infographic")
		: entry;
	if (infographicHeadline) {
		infographicHeadline
			.querySelector(".ddiff-animated-exhibit-headline")
			.classList.add("ddiff-animated-exhibit-headline-animate");
	}
};

const showStaticInfographic = () => {
	const infoGraphicBorder = document.querySelectorAll(".ddiff-animated-exhibit-border");
	if (infoGraphicBorder.length) {
		infoGraphicBorder.forEach((infoGraphic) => {
			if (isContentMax() && document.querySelector(`.ddiff-animated-exhibit-headline-animate`)) {
				infoGraphic.classList.add("ddiff-animated-exhibit-border-static");
			} else {
				infoGraphic.classList.remove("ddiff-animated-exhibit-border-static");
			}
			if (!isContentMax()) infoGraphic.classList.add("ddiff-animated-exhibit-border-static");
		});
	}
};

const showInfographicMobileToLarge = () => {
	const infographics = document.querySelectorAll(".ddiff-animated-exhibit-infographic");
	infographics.forEach((infographic) =>
		infographic.classList.add("ddiff-animated-exhibit-infographic-static")
	);
};

export {
	animateInfographic,
	animateInfographicHeadline,
	showStaticInfographic,
	showInfographicMobileToLarge
};
